<div class="header">
	<div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'" [ngClass]="{'menuShowing': selectedArticle !== null}">
		<div class="contentInner">
			<div class="pageTitle">
			  <h1 class="headline">User guide</h1>
			</div>
		</div>
    <div class="topicTabsContainer" *ngIf="selectedArticle !== null">
      <div class="menuNotifier" [innerHtml]="topicTitles[selectedArticle]" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()"></div>
      <div class="topicTabs" [ngClass]="{ 'open': navbarOpen }">
        <a *ngFor="let topic of objectKeys(topicTitles)" [routerLink]="'/guide/'+topic" class="topicTab" [ngClass]="{ 'selected': selectedArticle === topic }" (click)="closeNavbar()">{{topicTitles[topic]}}</a>
      </div>
      <div class="chevron" [ngClass]="{ 'open': navbarOpen }" tabindex="0" role="link" (click)="toggleNavbar()" (keypress)="toggleNavbar()"></div>
    </div>
	</div>
</div>

<div>
<p *ngFor="let topic of objectKeys(topicTitles)" ></p>
</div>


<div class="content menu" *ngIf="selectedArticle === null" [class.noWebp]="noWebp">
  <div class="contentInner">
    <p class="intro">Set up Dash on your device, master its features, and learn how to get the most out of Dash for
      your organization.  Our user guide has everything you need to know.</p>
    <p  class="intro">Can't find the answer you're looking for here?  <a routerLink="/contact">Contact us</a> and we'll be happy to help.
    </p>
    <div class="topicButtons">
      <a class="topic quickStart" routerLink="quickStart"><div class="icon"></div><div class="title">Quick Start Guide</div><p>A quick guide to getting Dash up and running.</p></a>
      <a class="topic officeSetup" routerLink="officeSetup"><div class="icon"></div><div class="title">Microsoft 365 setup</div><p>Set up Microsoft 365 and connect it to Dash.</p></a>
      <a class="topic googleSetup" routerLink="googleSetup"><div class="icon"></div><div class="title">Google <br>setup</div><p>Set up Google Workspace or personal Google account, and connect it to Dash.</p></a>
      <a class="topic deviceSetup" routerLink="deviceSetup"><div class="icon"></div><div class="title">Android/iOS setup</div><p>Get your device set up to run Dash.</p></a>
      <a class="topic usingDash" routerLink="usingDash"><div class="icon"></div><div class="title">Using Dash</div><p>A comprehensive guide to everything Dash.</p></a>
      <a class="topic enterprise" routerLink="/enterprise"><div class="icon"></div><div class="title">Dash Enterprise</div><p>Centrally manage your Dash displays with Dash Enterprise.</p></a>
      <a class="topic practices" routerLink="practices"><div class="icon"></div><div class="title">Practices</div><p>Helpful hints on getting the most out of Dash.</p></a>
    </div>
  </div>
</div>

<div class="content deviceSetup" *ngIf="selectedArticle === 'quickStart'">
  <div class="contentInner">
    <h2 class="sectionHeader">Getting Started with Dash</h2>
    <p class="intro">
      Follow these steps to be up and running with Dash in no time.  This guide will help you complete your initial set-up,
      and walk you through the key features and options you need to get the most out of Dash.
    </p>

    <h3>1. Connect your calendars to Dash</h3>
    <p>If you are using <i>Microsoft Microsoft 365</i> or <i>Google Workspace</i> then you can complete all the
      necessary steps from within Dash.  Please see our guides on <a routerLink="../officeSetup">Microsoft 365 Setup</a> and
      <a routerLink="../googleSetup">Google Setup</a> for instructions on how to set up your Microsoft 365/Google Workspace
      account correctly and connect it to Dash.
    </p>
    <p>
      If you are using a different system to manage your meeting room calendars (for example a local <i>Exchange</i> server or
      <i>CalDav</i>) then you can connect your device to the service and Dash will read your meeting information from your
      device's calendar.  Please see the section on <i>Using Dash with your device's calendar</i> in our
      <a routerLink="../deviceSetup" fragment="calendarSetup">Device Setup</a> guide for information on how to do this.
    </p>

    <h3>2. Choose how meetings are displayed</h3>
    <p>
      Dash features a number of ways to customize the way your meeting information is displayed which can all be found
      in the <i>Calendar and display</i> section of Dash's settings.
    </p>
    <ol>
      <li><b>Rename calendars - </b>Your meeting rooms might not always be named the way you want in your calendars.  If
        you find this is the case, Dash allows you to rename them.  Select <i>Rename calendars</i>, tap on the calendar
        you wish to rename, and enter your desired name.
      </li>
      <li>
        <b>Customize the meeting schedule display - </b>By default, Dash displays your meetings in a calendar display of
        the current day so that you can clearly see when the meeting room is free.  Dash also supports displaying upcoming
        meetings in a list which can be more efficient if your meeting rooms are often fully booked.  Select <i>Display
        meetings as</i>, and choose a list of either today's meetings or include up to two days of future meetings.
      </li>
      <li>
        <b>Display only meetings accepted by the calendar - </b>If your meeting room calendar automatically declines
        new meetings that clash with existing ones (which is the case for both <i>Microsoft 365</i> room mailboxes and
        <i>Google Workspace</i> resources) then turn on this option to hide declined meetings.
      </li>
      <li><b>Time format and Language - </b>These options control whether times are displayed in a 12 or 24 hour format,
      and which of the 23 supported languages is used in the main sections of the app.  Dash will choose the best
        defaults based on your Device's location settings, but you can override this and choose your own time format
        and language.
      </li>
    </ol>

    <h3>3. Security</h3>
    <p>
      The <i>Security</i> section of Dash's settings gives you a number of controls which allow you to secure Dash's
      settings from unauthorized access and to control what meeting information is displayed on Dash's main display.
    </p>
    <ol>
      <li>
        <b>Require passcode to access settings - </b>If you wish to protect Dash's settings from unauthorized access,
        you can set a 4 digit passcode which must be entered before Dash's settings will open.  Turn on the option and
        enter your desired passcode twice to activate it.
      </li>
      <li>
        <b>Meeting Information - </b>If you have sensitive information in the titles of your meetings, you can use the
        <i>Label meetings with</i> setting to control what is displayed.  Choose from displaying the meeting's title,
        the meeting's organizer, or simply show that the room is booked without revealing the title or organizer.  When
        turned off, the <i>Display meeting details</i> setting will prevent the meeting's description and list of
        participants from being shown when a meeting is tapped on the main screen.
      </li>
    </ol>

    <h3>4. Optional Features</h3>
    <p>
      Dash offers a number of powerful features to help you manage your meeting rooms, available in the <i>Optional
    features</i> section.  The ideal combination of settings will differ from organization to organization so we
      recommend that you trial different settings before settling on the combination that works best for you.
    </p>
    <ol>
      <li>
        <b>Ending and extending meetings - </b>If a meeting is running longer than expected, Dash can allow users to
        extend it if the room is available.  Conversely, if a meeting ends earlier than expected the booking can be
        ended early to free the room for other meetings.
      </li>
      <li>
        <b>Check-in - </b>One of the largest causes of meeting room inefficiency is abandoned bookings - meetings which
        are booked in the room but then not attended.  Dash can help to prevent these with the <i>Check-in</i> feature.
        When turned on, a Check-in button will be displayed on the main screen for each meeting.  If this button is not
        pressed 10 minutes after the meeting was scheduled to start then the meeting will be cancelled and the room will
        be available for other bookings.
      </li>
      <li>
        <b>Room booking - </b>Dash can also allow users to book the room directly from the screen.  When the <i>Allow
      booking</i> option is turned on, users will be able to book the room if it is available.  Bookings will start from
        the time the <i>Book now</i> button is pressed, and users have a choice of booking the room for 15 minutes,
        30 minutes, 1 hour, or 2 hours.  If the <i>Users can set a message when booking</i> feature is turned on, then
        users will be given the option to set a meeting title and message before completing their booking.
      </li>
      <li>
        <b>Find free rooms - </b>If the room is currently booked, the <i>Find free rooms</i> feature allows users to find
        other free rooms in the building.  When turned on, the <i>Find free rooms</i> option adds a button to the main
        screen that lists all rooms currently free.  Select the rooms you want to include using the <i>Rooms to check</i>
        option and they will be displayed in the list.  The list is ordered by the amount of free time, so the room with
        the most free time is displayed first.
      </li>
    </ol>

    <h3>5. Customize Branding</h3>
    <p>
      Dash allows you to choose your own background image.  Dash supports any size of background image - the image
      chosen will be scaled so that it covers your devices display.  For best results, you should create an image that
      exactly matches the size of your device's display in pixels.  To find the ideal background image size for your
      device, open the <i>Appearance and branding</i> section of Dash's settings.  The ideal size will be shown just underneath
      the option for setting the background image.
    </p>
    <p>
      Dash also allows you to display a custom logo.  The chosen logo will appear at the top of the main screen.
      The ideal image size for a custom logo is 500 x 100 pixels, however you can use an image with a different size and
      it will be scaled to fit.  If you would like to have your logo appear in a different part of the main display you
      can add it to your background image instead of loading it separately.
    </p>
    <p>
      Dash also allows you to customize the colors of visual elements such as buttons, text, and dialog backgrounds.
      For a full list of the customization options please see the <i>Appearance and branding</i> section of our
      <a routerLink="../usingDash">full guide</a>.
    </p>

    <p>&nbsp;</p>

    <p class="intro">Congratulations!  You have finished setting up Dash.  You can learn more about the available settings in our
      <a routerLink="../usingDash">Full guide</a>, and if you have any questions or comments feel free to
      <a routerLink="/contact">Contact us</a> - we're here to help!</p>
  </div>
</div>


<div class="content officeSetup" *ngIf="selectedArticle === 'officeSetup'">
  <app-guide-o365 *ngIf="selectedSubArticle === null"></app-guide-o365>
  <app-guide-o365-service-account *ngIf="selectedSubArticle === 'o365-service-account'"></app-guide-o365-service-account>
  <app-guide-o365-enterprise-application *ngIf="selectedSubArticle === 'o365-enterprise-application'"></app-guide-o365-enterprise-application>
  <app-guide-o365-powershell *ngIf="selectedSubArticle === 'o365-powershell'"></app-guide-o365-powershell>
</div>


<div class="content googleSetup" *ngIf="selectedArticle === 'googleSetup'">
  <div class="contentInner">

    <app-guide-google *ngIf="selectedSubArticle === null"></app-guide-google>
    <app-guide-google-personal-account *ngIf="selectedSubArticle === 'google-personal-account'"></app-guide-google-personal-account>
    <app-guide-google-service-account *ngIf="selectedSubArticle === 'google-service-account'"></app-guide-google-service-account>






  </div>
</div>

<div class="content deviceSetup" *ngIf="selectedArticle === 'deviceSetup'">
  <div class="contentInner">

    <h2 class="sectionHeader">Locking your device</h2>
    <p class="intro">
      The following settings can be used to lock your device to stop people from closing Dash and accessing other apps.
      When enabled, users will have to enter a pin code before they can close Dash.
    </p>

    <h3>Guided Access (iOS devices)</h3>
    <p>
      <i>Guided Access</i> is an optional feature on your device that restricts users to using only a single application.
      It can be used to prevent users from closing Dash (for example if your meeting room screen is in a public place)
    </p>
    <p>
      To learn more about Guided access and how to enable it for your device, visit the
      <a href="https://support.apple.com/HT202612">Apple support page</a> on the topic.  Once you have set up <i>Guided
      Access</i>, open Dash and activate <i>Guided Access</i> by triple clicking the home button of your device (or the
      side button if your device does not have a home button) and tapping <i>Start</i>.
    </p>
    <p>
      You may also wish to disable the sleep/wake button of your device.  To do this, triple click the home button to
      activate <i>Guided Access</i> and then tap <i>Options</i> and disable the sleep/wake button before tapping
      <i>Start</i>.
    </p>

    <h3>Screen pinning (Android devices)</h3>
    <p>
      <i>Screen pinning</i> is an optional feature on android devices running version 5.0 (Lollipop) or later that
      restricts users to using only a single application. It can be used to prevent users from closing Dash
      (for example if your meeting room screen is in a public place).
    </p>
    <p>
      To learn more about <i>screen pinning</i> and how to enable it for your device, visit the
      <a href="https://support.google.com/android/answer/9455138">Google support page</a> on the topic.  Once you have
      set up <i>Screen pinning</i>, open Dash and activate <i>Screen pinning</i> from the Android <i>Overview</i> view
      (see the above <i>Google</i> documentation for further instructions).
    </p>


    <h2 class="sectionHeader" id="calendarSetup">Using Dash with your device's calendar</h2>

    <p class="intro">
      If you are not using Microsoft 365 or Google Workspace, then you can connect your device directly to any calendar
      provider that it supports and Dash will display the meeting information.
    </p>

    <h3>Adding calendars to your iOS device</h3>
    <p>
      Go to the <i>Settings</i> app on your iPhone or iPad, and go to <i>Accounts & Passwords</i>.  Select the type of
      account you would like to add.  If you do not see your account type in the list, it may be listed under <i>Other</i>.  Follow the instructions on screen
      to enter your credentials and add the account to your device.
    </p>
    <p>
      You will have a choice of what information to sync between your account and your device (for example <i>Mail</i>,
      <i>Contacts</i>, and <i>Calendars</i>).  It is recommended to turn off everything except <i>Calendars</i> to speed
      up syncing.
    </p>

    <p>
      At the bottom of the <i>Accounts & Passwords</i> settings screen, you will see a <i>Fetch New Data</i> option.
      Select it and make sure that <i>Push</i> is turned on.  At the bottom of the screen you will see an option for
      <i>Fetch</i> frequency.  Make sure that this is set to <i>Automatically</i>.
    </p>


    <h3>Adding calendars to your Android device</h3>
    <p>
      Go to the <i>Settings</i> app on your phone or tablet, and go to <i>Accounts</i>.  Click <i>Add account</i> and select the type of
      account you would like to add.  For some services not natively supported by your device (e.g. for CalDav) you will
      need to install a separate app that functions as a 'sync adapter' in order to see your service in this list.
      Once you have selected your service, follow the instructions on screen to enter your credentials and add your
      account to your device.
    </p>
    <p>
      Once your account has been added to your device, go to <i>Account sync</i>.  You will have a choice of what
      information to sync between your account and your device (for example <i>Mail</i>,
      <i>Contacts</i>, and <i>Calendars</i>).  It is recommended to turn off everything except <i>Calendar</i> to speed
      up syncing.
    </p>
    <p>
      You can now select your calendar from Dash.  Open Dash, go to Settings, choose the 'Calendar' option and select
      the calendar for your meeting room from the list.
    </p>
  </div>
</div>




<div class="content usingDash" *ngIf="selectedArticle === 'usingDash'" [class.noWebp]="noWebp">
  <div class="contentInner">
    <h2 class="sectionHeader" id="mainScreen">The main screen</h2>
    <p class="intro">This is the main meeting display.  From here you can see details of the current meeting, look at
      the day's schedule, or make a new booking.  Dash's main screen can be shown as either a room or dashboard display.
    </p>
    <p>
      See below the illustration for detailed information about each part of the display, and see the
      <a routerLink="." fragment="configuration">configuration section</a> for how to select the room or dashboard
      display.
    </p>

    <div class="toggleContainer">
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'room' }" (click)="toggleOverviewIllustration('room')" (keypress)="toggleOverviewIllustration('room')">Room display</div>
      <div role="link" href="#" [ngClass]="{ 'selected': overviewIllustration === 'dashboard' }" (click)="toggleOverviewIllustration('dashboard')" (keypress)="toggleOverviewIllustration('dashboard')">Dashboard display</div>
    </div>

    <div role="img" aria-label="Dash main screen" class="mainScreenIllustration" [ngClass]="{ 'dashboard': overviewIllustration === 'dashboard' }"></div>

    <ol class="stepList">
      <li>
        <b>Current time - </b>Dash takes the time of day from your device's clock, which can
        be changed in your device's settings.  Dash can also display the date on the main screen.
      </li>
      <li><b>Meeting room name - </b>The name of the calendar you have selected.</li>
      <li>
        <b>Current/upcoming meetings - </b>The current meeting name, duration, and number of participants is displayed.
        If there is another meeting starting in the next ten minutes, it is displayed below.
      </li>
      <li>
        <b>Meeting tools (optional) - </b>These tools allow you to check-in, extend, or end a meeting early.  <br><br>See
        <a routerLink="." fragment="optionalFeatures">optional features</a> for more information.
      </li>
      <li>
        <b>Schedule display  - </b>The schedule display shows the meeting plan for the day (or days depending on your
        settings).  It can be configured to show a list of upcoming meetings, or a calendar view of the day.  Tap on a
        meeting to view detailed information about the meeting.<br><br>The display
        is coloured by the meeting status (one of <i>Free</i>, <i>Occupied</i>, or <i>Soon to be occupied</i>).
      </li>
      <li>
        <b>Book/Book now (optional) - </b>Allows you to make impromptu room bookings for up to two hours, or optionally also book
        meetings in the future.<br><br>See <a routerLink="." fragment="optionalFeatures">optional features</a> for more information.
      </li>
      <li>
        <b>Find a room (optional) - </b>Allows you to find a free meeting room in the building.  <br><br>See
        <a routerLink="." fragment="optionalFeatures">optional features</a> for more information.
      </li>
      <li>
        <b>Settings - </b>Access the app settings to select a meeting room calendar, configure optional features, or
        customize branding.
      </li>
    </ol>

    <h2 class="sectionHeader" id="configuration">Configuration</h2>

    <p class="intro">The following settings allow you to customize your Dash experience.  Use them to choose the room
      calendar to display, activate and configure optional features, or control the branding and apperance of the room
      display.  The settings screen can be accessed from the <i>Configuration</i> screen by tapping the cog icon on the
      main screen.
    </p>

    <div class="settingsContainer">
      <div class="settingsCol">

        <h3 id="calendar">Calendar and display</h3>
        <p><b>Display mode - </b>Choose between two display modes for Dash: A <i>room display</i> which shows the status
          of a single meeting room calendar, along with a schedule view, or a <i>dashboard display</i> which shows the
          status of multiple meeting rooms at once.</p>
        <p><i>See the <a routerLink="." fragment="mainScreen">main screen</a> overview above for an illustration of
        both the room and dashboard displays</i>
        <p><b>Calendar/Calendars - </b>Select the calendar for the meeting room you would like to display (one calendar
          if <i>Display mode</i> is set to <i>room display</i>, or one or more calendars if it is set to
          <i>dashboard display</i>).  If you do not see your calendar in the list, make sure that it has been added to
          your device by following the instructions in
          <a routerLink="/guide/officeSetup">Microsoft 365 Setup</a> or <a routerLink="/guide/googleSetup">Google Setup</a>.
        </p>
        <p class="tip icon">Some optional features (such as ending and extending meetings, and requiring user check-in) require
          write access to the calendar.  These features will not be available if a read-only calendar is selected.
        </p>

        <p><b>Display as - </b>Controls how your meetings are displayed on the main screen.  You have a choice of four options.
          <i>A calendar view of today's meetings</i> shows you the entire day's meetings, while also showing gaps between
          meetings.  The other three options show a list of all current and future meetings, providing a more compact view.
        </p>

        <p><b>Status display - </b>Controls how the meeting room and time are shown on the main display.  Choose
          <i>Large room name</i> to emphasize the room name, or choose <i>Large clock</i> to emphasize the current time.
        </p>

        <p><b>Show date on main screen - </b>Shows the current date on Dash's main screen.
        </p>

        <p><b>Date format - </b>The format to use for dates shown in Dash (both on the main screen and for meetings).
          "Auto" chooses an appropriate format based on your device's locale, and the other options display the date
          as indicated.
        </p>

        <p class="tip icon">Note that the exact format of the date is influenced by your selected language, so we
          recommend choosing your language before selecting a date format.
        </p>

        <p><b>Show all-day meetings - </b>If this option is turned on then all-day meetings will be shown on the display, and will
          be included when deciding if the room is free or busy.
        </p>

        <p><b>Display only meetings accepted by the calendar - </b>If this option is selected then only meetings that have been
          accepted by the meeting room's calendar will be shown.  This is particularly useful in eliminating double
          bookings, as a second booking made in an occupied timeslot will not be shown.  This feature requires your calendar
          to automatically reject double bookings.
        </p>

        <p><b>Show room occupancy by color - </b>Dash can display different colors depending on the room's current availability.
          Different colors are shown if the room is currently free, booked, or almost booked (currently free but will be booked within the next
          10 minutes).  <br><br>This option allows you to choose to have the colors displayed behind the schedule view, or in a
          border around the whole display.  The colors for each state can be set in <a routerLink="." fragment="appearance">Appearance and branding</a>.
        </p>

        <p><b>Dim screen after hours - </b>If this option is selected then Dash will dim the meeting room display after
          hours and display a screensaver showing the meeting room name and the current time.  Dash will resume when the
          screen is tapped.  The start and end time of your working hours will be visible when editing this setting.
          Tap on them to change them.
        </p>

        <p><b>Font size - </b>Choose the size that visual elements such as buttons and text are displayed in Dash.  This
          setting has a larger effect on small text such as buttons and labels, and a smaller effect on larger text such
          as room names and headings.  <br/><br/>Dash also respects your system font scaling, so if you would like to change the
          size of all text elements equally, you can change the text size in your device's system settings.  You can use
          the system font settings and Dash's font settings at the same time for full control over the size of text in
          Dash.
        </p>

        <p><b>Time format - </b>Choose whether to display times in a 12-hour or 24-hour format.  The default time format
          will be chosen based on your tablet's locale settings.
        </p>

        <p id="languages"><b>Language - </b>Choose the language used in Dash.  The following languages are available in both the main
          display and settings areas of Dash:
        </p>
        <ul>
          <li>English</li>
          <li>Danish</li>
          <li>German</li>
          <li>Portugese (Brazil)</li>
        </ul>
        <p>And the following languages are available in the main display areas of Dash:</p>
        <ul>
          <li>Azerbaijani</li>
          <li>Czech</li>
          <li>Dutch</li>
          <li>French</li>
          <li>Hebrew</li>
          <li>Hungarian</li>
          <li>Italian</li>
          <li>Indonesian</li>
          <li>Japanese</li>
          <li>Korean</li>
          <li>Lithuanian</li>
          <li>Malay</li>
          <li>Norwegian</li>
          <li>Polish</li>
          <li>Romanian</li>
          <li>Russian</li>
          <li>Serbian</li>
          <li>Slovak</li>
          <li>Spanish (Latin America)</li>
          <li>Swedish</li>
          <li>Turkish</li>
          <li>Ukrainian</li>
        </ul>
        <p>The default language will be chosen based on your tablet's locale settings.</p>

        <p>If you have any questions
          about the languages supported, or would like to request a translation of Dash into your language, please
          <a routerLink="/contact">contact us</a>.
        </p>

        <h3 id="subscription">Subscription</h3>
        <p>The subscription section is where you can manage your subscription to Dash Business.  If you are currently
          subscribed, tap <i>Manage subscription</i> to go to the Apple App Store or Google Play Store to manage your
          Dash subscription.  You can also upgrade or downgrade the number of devices in your subscription at any time
          by using the devices slider.  Dash currently supports up to 10 devices for its in-app subscriptions.  If you
          would like to use Dash on more than 10 devices, please <a routerLink="/contact">Contact us</a></p>

        <p>On Apple devices, if you are currently subscribed to our monthly Dash Business plan and do not see your
          subscription in Dash, tap <i>Restore Purchases</i> to make sure that Dash is showing your latest subscription
          information.
        </p>

        <p>The subscription section also allows you to register your copy of Dash if you are subscribed to our <b>Dash
          Enterprise</b> plan.  To do this, tap the <i>Enterprise license</i> button, and then enter your license key,
          or a pairing code obtained from our <a routerLink="/enterprise/dashboard">web management dashboard</a>.
        </p>

      </div>

      <div class="settingsCol">

        <h3 id="security">Security</h3>
        <p><b>Require a passcode to access settings - </b>If selected, you will be asked to enter a 4-digit security code.
          This code will be required in order to access settings from the main screen.
        </p>

        <p><b>Label meetings with - </b>This setting controls the title displayed against each meeting on the schedule display,
          and in the detailed information about each meeting.  The following options are available:
        </p>
        <ul>
          <li><b>Meeting title - </b>This is the title of the meeting, as displayed in the meeting room's calendar.</li>
          <li><b>Meeting organizer - </b>If the meeting has an organizer, then their name will be displayed (or their email
            address if their name is not available).  Meetings with no organizer will have the title "Room booked".</li>
          <li><b>No title or organizer - </b>All meetings will have the title "Room booked"</li>
        </ul>

        <p><b>Display meeting details - </b>By default, Dash will display detailed information about a meeting when it is
          clicked in the schedule display.  This detailed information includes:
        </p>
        <ul>
          <li>The meeting title</li>
          <li>The meeting description (including information about any video calls associated with the meeting).  <i>Displaying the meeting description is optional (see below)</i>.</li>
          <li>A list of attendees which may include email addresses</li>
        </ul>
        <p>Disabling the meeting details option will prevent this information being displayed to users of the display.</p>
        <p><b>Include meeting description - </b>By default, Dash will display the meeting description when the meeting
          details are displayed.  Disable this to show only the meeting title and attendee information.
        </p>

        <h3 id="optionalFeatures">Optional features</h3>

        <p><b>Require check-in - </b>When selected, users will be required to check-in to meetings when they enter the room.
          This can be done by tapping a check-in button on the main screen, and must be done within ten minutes of the
          meeting starting.  Meetings not checked-in after this time will be automatically ended.
        </p>
        <p class="tip icon">The check-in feature writes a small amount of text to the calendar event's description when the meeting is
          checked-in.
        </p>

        <p><b>Allow booking - </b>Allows users to book the meeting room (if its schedule allows).  Choose between:
        </p>
        <ul>
          <li><b>Booking not allowed - </b>When selected, users are able to book the room (if its schedule allows).  </li>
          <li><b>Instant bookings only - </b>The room may be booked immediately for 15 minutes, 30 minutes, one hour, or two hours.</li>
          <li><b>Instant and later bookings - </b>The room may be booked immediately, and also in advance.</li>
        </ul>
        <p>When booking is enabled, then the following options can be configured:</p>
        <h4>These settings apply to all bookings:</h4>
        <p class="indent"><b>Require a passcode to book from the display - </b>If turned on, this setting requires users to
          enter a 4-digit passcode before making bookings from the display.  This setting affects instant and future
          bookings, as well as bookings made from the find a free room feature.
        </p>
        <p class="indent"><b>Also require the passcode to end or extend meetings - </b>If turned on, users will also need
          to enter the passcode to make changes to meetings, such as extending them or ending them early.
        </p>
        <p class="indent"><b>Suggested booking lengths - </b>this setting affects the length of time suggested when the user is booking the room:
        </p>
        <ul class="indent">
          <li><b>Friendly booking end times - </b>Booking lengths will be chosen so that your booking finishes at a round time (such as on the hour).</li>
          <li><b>Friendly booking lengths - </b>Round booking lengths will be suggested (for example 30 minutes or 1 hour)</li>
        </ul>

        <p class="indent"><b>Include video conferencing - </b>this setting allows you to contol whether a video conference link is added to bookings made from the Dash display:
        </p>
        <ul class="indent">
          <li><b>Always - </b>A video conference link is included with all bookings.</li>
          <li><b>Never - </b>No vide conference links are included with any bookings</li>
          <li><b>Per booking - </b>Dash will ask the user at the time a booking is being made</li>
        </ul>

        <p class="indent"><b>Users can add attendees when booking - </b><i>(only available for Microsoft 365 Enterprise Application connections)</i>.  Users can add attendees (both inside and outside your organization) when booking from the Dash display.  The attendees will receive a calendar invite with a videoconferencing link.</p>

        <h4>These settings appear twice, and can be set separately for instant and later bookings:</h4>

        <p class="indent"><b>Users can set a message when booking - </b>When selected, users are able to set their own meeting title and description when making impromptu bookings.  When set to <i>Optional</i>, a default meeting title is pre-entered.  When set to <i>Required</i> there is no default title, and the user must enter a title.</p>

        <p class="indent"><b>Users can set the organizer when booking - </b><i>(only available for Microsoft 365 Enterprise Application connections)</i>.  Users can choose a member of your organization to be the meeting's organizer.  The meeting will be created in the member's calendar and the meeting room will be set as the meeting's location.  When set to <i>Optional</i> the user can book a meeting without selecting an organizer (in which case the booking will be created in the meeting room's calendar only).  If set to <i>Required</i> then the user must choose an organizer.</p>

        <p>&nbsp;</p>

        <p><b>Allow ending meetings - </b>When selected, users are able to end the current meeting directly from the main screen.
          It is also possible to end upcoming meetings that are starting in the next ten minutes.
        </p>

        <p><b>When ending meetings - </b>There are two options for ending meetings:
        </p>
        <ul>
          <li><b>Delete the meeting - </b>this will completely remove the meeting from the meeting room's calendar</li>
          <li><b>Change the meeting finish time - </b>This will bring forward the meeting end time.  Note that if this would cause
            the meeting duration to be less than one minute, it will be deleted instead.</li>
        </ul>
        <p>Note that this setting does not affect the way that meetings are ended by the <i>check-in</i> feature (see below).  Meetings ended due to not being checked in are always deleted.</p>

        <p><b>Allow extending meetings - </b>When selected, users are able to extend the current meeting (if the room
          schedule allows).  The meeting may be extended by 15 minutes, 30 minutes, one hour, or two hours.
        </p>

        <p class="tip icon">When allowing ending or extending meetings, choosing to allow "only for meetings
          booked from a Dash display" restricts ending or extending meetings to only meetings with no organizer, or
          where the organizer is the conference room.<br><br>This is usually the case for meetings booked from the Dash
          display but can also apply to meetings booked directly in the conference room's calendar by an admin.

        </p>

        <p><b>Find free rooms - </b>When selected, users are able to search for other free rooms in the building, and also book them (if the <i>Allow Booking</i> setting is enabled).  </p>
        <p>Rooms
          that are either free now, or will be free in the next ten minutes are included in the list, and the rooms are
          ordered by the length of time available (with the longest time listed first).
        </p>

        <p><b>Rooms to check - </b>The list of calendars to search when checking for free rooms.  You may select as many
          calendars as you would like.
        </p>
        <p class="tip icon">
          If you do not see all your rooms in the list, make sure that they have been added
          to your device by following the instructions in
          <a routerLink="/guide/officeSetup">Microsoft 365 Setup</a>, <a routerLink="/guide/googleSetup">Google Setup</a>,
          or <a routerLink="../deviceSetup" fragment="calendarSetup">Android/iOS Setup</a> (depending on which method you are using to connect
          Dash to your calendars).
        </p>
      </div>

    </div>


    <h3 id="appearance">Appearance and branding</h3>
    <div class="settingsContainer">
      <div class="settingsCol">
        <p>Appearance and branding allows you to customize the appearance of Dash to match your company branding.
          You can customize the colors of most elements of the user interface, as well as choose a custom background image
          and logo for the app.
        </p>
        <p>You are able to choose custom colors for the following components:
        </p>
        <ul>
          <li><b>Background color - </b>The background color of the main display.  If you also choose a background image this color will appear behind it.</li>
          <li><b>Text color - </b>The color of text in the main display, and also in dialogs used for booking or finding rooms.</li>
          <li><b>Button color - </b>The color of buttons.</li>
          <li><b>Button border color - </b>The color of the border around buttons.  Set this to transparent for no border.</li>
          <li><b>Button text color - </b>The color of the text inside buttons.</li>
          <li><b>Dialog background color - </b>The background color of dialogs used for room booking, meeting details, and room finding.</li>
          <li><b>Room free color - </b>The color used to indicate that the room is currently free.</li>
          <li><b>Room almost booked color - </b>The color used to indicate that the room is currently free, but will be occupied in the next ten minutes.</li>
          <li><b>Room booked color - </b>The color used to indicate that the room is currently occupied.</li>
        </ul>
        <p>Each of these colors can be tested in the live preview.  The booking status of the preview can be changed
          using the toggle buttons above the main display.
        </p>
      </div>
      <div class="settingsCol">
        <div role="img" aria-label="Dash branding screen" class="illustration brandingIllustration"></div>
        <p>Dash allows you to set a <b>custom background image</b> for the display.  This can contain your logo, or other company
        colors and imagery, and can be used to further personalize the display with your branding.</p>
        <p>It is recommended that you use an image with the same aspect ratio as your device, but if a different aspect
          ratio is used then Dash will scale the image so that the view is always entirely filled.
        </p>
        <p class="tip icon">
          For best results, you should create an image that exactly matches the size of your device's display in pixels.
          This ideal size for your device is shown underneath the <i>Background image</i> option.
        </p>
        <p>
          Dash also allows you to display a <b>custom logo</b>.  The chosen logo will appear at the top of the main screen.
          The ideal image size for a custom logo is <i>500 x 100 pixels</i>, however you can use an image with a different size and
          it will be scaled to fit.  If you would like to have your logo appear in a different part of the main display you
          can add it to your background image.
        </p>
      </div>
    </div>


    <h2 class="sectionHeader" id="bookingAndCheckIn">Booking and check-in</h2>
    <p class="intro">Book your room from the screen, find free rooms close by, and clear unused bookings automatically.
      Learn how to use Dash's advanced features to manage your meeting spaces.  All advanced features are optional, so
      make sure that you have activated and configured them by following the configuration instructions above.</p>

    <div class="settingsContainer">
      <div class="settingsCol">
        <h3 id="booking">Booking</h3>
        <p>The booking controls can be found at the bottom right corner of the main display (for horizontal devices),
          or at the bottom of the display (for vertical devices).  To book the room, tap the button labelled
          <i>Book now</i>.
        </p>

        <p>You will be presented with a booking screen showing four approximate durations: 15 minutes, 30 minutes, 1 hour, and
          2 hours.  Tap the length of time you would like to book, and a booking will be made with the title
          "Manually booked".
        </p>

        <p>If you have chosen to allow booking the room in advance, there will also be a button <i>Book a later time</i>.
          Tapping this button will bring up a calendar display (showing a week on larger devices, or a day on smaller devices).
        </p>

        <p>Move the calendar view backwards and forwards in time by pressing the arrow buttons on either side of the
          dates, or choose a date from the picker by tapping on the month displayed in the center of the screen.  To make
          a booking, tap on an empty space in the schedule, and drag the booking to refine.  When you're done, press the
          <i>Book</i> button at the bottom of the screen.  Note that users are always able to set the title and
          description of advance bookings, regardless of the value set for <i>Users can set a message when booking</i>
          in <i>Settings</i>.
        </p>

        <p class="tip icon">If the room is currently booked, impromptu booking will
          be disabled.  If future booking is enabled, Dash will launch the calendar view without showing the impromptu
          booking screen.
        </p>
        <div role="img" aria-label="Dash booking screen" class="illustration bookingIllustration"></div>


        <h3 id="checkIn">Check-in</h3>
        <p>The check-in feature requires all meetings to be manually checked-in when they start.  To check-in a meeting,
          click the <i>Check in</i> button in the current/upcoming meetings section of the main screen.
        </p>
        <p>If a meeting is not checked-in within the specified time (see below), it will be automatically ended to free the
          room for other uses.
        </p>

        <h3 id="releaseAfter">Release room after</h3>
        <p>The amount of time after a meeting's scheduled start time that Dash will wait for the check in button to be pressed before ending it.
        </p>
        <p>If <i>Don't release</i> is selected, the meeting will be displayed as tentative on the display until the
          check-in button is pressed but Dash won't end the meeting if it isn't checked in..
        </p>

      </div>

      <div class="settingsCol">
        <h3 id="extend">Extending and ending meetings</h3>
        <p>The current meeting can be extended if there is space in the room's schedule.  To extend a meeting, tap the
        <i>Extend</i> button in the current/upcoming meetings section of the main screen.
        </p>
        <p>You will be presented with a screen similar to the booking screen, showing four durations: 15 minutes,
          30 minutes, 1 hour, and 2 hours.  Tap the length of time you would like to extend, and the booking will be
          adjusted.
        </p>
        <p>The current meeting can also be ended by tapping the <i>End now</i> button.  The meeting will either be
          removed from your calendar, or edited to end at the current time, depending on the setting you chose for
          <i>When ending meetings</i> in the settings screen.
        </p>
        <div role="img" aria-label="Dash extend a meeting screen" class="illustration extendIllustration"></div>

        <h3 id="findRooms">Find a room</h3>
        <p>Before using this feature, you need to select the calendars you would like to check (see the <i>Rooms to check</i>
          option in the <i>Configuration</i> settings described above).
        </p>
        <p>The free rooms controls can be found at the bottom right corner of the main display (for horizontal devices),
          or at the bottom of the display (for vertical devices).  To find a free room, tap the button labelled
          <i>Find a room</i>.
        </p>
        <p>You will be presented with a booking screen showing all free rooms found.  The list is ordered with the rooms
          having the most free time appearing first.  You are able to book your desired room by tapping the corresponding
          <b>Book now</b> button.  To complete your booking, follow the booking instructions above to select your desired
          amount of time.
        </p>
        <div role="img" aria-label="Dash find free rooms screen" class="illustration findRoomsIllustration"></div>



      </div>
    </div>


  </div>
</div>



<div class="content practices" *ngIf="selectedArticle === 'practices'">
  <div class="contentInner">
    <h2 class="sectionHeader">Practices</h2>
    <p class="intro">These tips will help you get the most out of Dash by making sure that you're using your meeting rooms as efficiently as possible.</p>

    <h3>Always respect bookings</h3>
    <p>Systems work the best when everyone understands them, and everyone follows them equally.  To this end, we
      recommend the following rules for meeting room bookings:</p>
    <ul>
      <li><b>Always make a booking when using a room</b> even for a 15 minute impromptu meeting.  This ensures
        that everyone in your organisation knows the room is taken, and don't come half way across the building only to
        find a meeting already in progress.  You can reserve a room directly from the display using Dash's
        <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">Book now</a> feature.</li>
      <li><b>Clear your booking if your meeting finishes early</b> to allow everyone else to know that the room is free.
        You can end a meeting directly from the display using Dash's
        <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">End now</a> feature.</li>
      <li><b>If you do not have a booking and someone else does, give the room up to them.</b>  This works best when
        followed by everyone in the company, from the C.E.O. to an intern.  It encourages everyone to use the booking
        system (see above), and that they've allocated the appropriate amount of time to their meeting.  For meetings that run over, you
        can always use Dash to <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">extend</a> them.  If you
        need a meeting space that is booked, you can negotiate in advance with the booking owner to change the time or
        location of their booking.</li>
      <li><b>Use the <a routerLink="/guide/usingDash" fragment="bookingAndCheckIn">Check-in</a> feature</b> to ensure that meeting bookings are adhered to.  Since a meeting will be
        cleared if not checked-in within 10 minutes of its start time, attendees are encouraged to start the meeting on
        time - eliminating wasted space.</li>
    </ul>

    <h3>Different rooms for different purposes</h3>
    <p>Different rooms can be suitable for different purposes.  For example, a large meeting will not fit in a two
      person room, and a two person meeting can be a waste of resources if booked in a large room.  Facilities such as
      teleconferencing can also make a room more suitable for particular meetings.</p>
    <p>It can be useful to publish information on the size and facilities offered in each meeting room in your organization,
      and to include a guide on the types of meetings appropriate for each one.</p>

    <h3>Meeting efficiency</h3>
    <p>Inefficient meetings can be one of the biggest productivity costs in any business.  Dash can help you by making
      sure the space is available for you, but we also recommend considering the following tips to maximize the value
      you get from your meetings:</p>
    <ul>
      <li><b>Keep meetings short - </b>A poorly structured meeting can easily run over time.  While it is easy to extend
        a meeting with Dash it is important to think about whether it's a good idea to.</li>
      <li><b>Have a clear purpose - </b>Everyone should know why they are at a meeting, and what you hope to achieve.</li>
      <li><b>Prepare in advance - </b>Meetings are best used for collaboration, so it can be helpful to send out
        information beforehand, and then reserve meeting time for discussion.</li>
      <li><b>End a meeting by listing next steps - </b>To ensure progress from each meeting, it can be helpful to list
        next steps.  These tasks and goals can be assigned to individuals or the team as a whole.</li>
      <li><b>Review who needs to attend - </b>Meetings form a large percentage of employee's time, which can then not be
        spent on their regular tasks.  Consider whether each invitee needs to be present at the meeting, or whether a
        meeting summary or minutes might be sufficient.</li>
    </ul>
  </div>
</div>
